import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

export const selectQuery = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): string | undefined => state.productDiscovery?.searchPage?.query;
